// extracted by mini-css-extract-plugin
export default {"forgotPasswordForm":"ForgotPassword_forgotPasswordForm__1C-FJ","passwordResetConfirmation":"ForgotPassword_passwordResetConfirmation__TEEXB"};